import { useCallback, useEffect, useState } from 'react'
import slugify from 'slugify'

export interface UseXclientProps {
  container: string
  clientId?: string
  product?: string
  assetmode?: string
  asset?: string
  limit?: number
  lang?: string
}

export interface UseXclientReturnType {
  data: XclientItem[]
  loading: boolean
}

export interface XclientItem {
  id: string
  postedat: string
  title: string
  description: string
  imageurl?: string
  category: string
  slug: string
}

const useXclient = ({ container, lang, clientId, product, assetmode, asset, limit }: UseXclientProps): UseXclientReturnType => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState<XclientItem[]>([])

  const handleData = useCallback((response: string) => {
    const { data } = JSON.parse(response)

    setData(data.map((item: XclientItem) => ({ ...item, slug: slugify(item.title, { lower: true }) })))
    setLoading(false)
  }, [])

  const handleAdded = useCallback(() => {}, [])

  useEffect(() => {
    if (window.Xclient) {
      setLoading(true)

      window.Xclient.render(
        {
          lang: lang?.substring(0, 2),
          clientId,
          product,
          assetmode,
          asset,
          limit,
          getData: handleData,
          added: handleAdded
        },
        container
      )
    }
  }, [container, lang, clientId, product, assetmode, asset, limit, handleData, handleAdded])

  return {
    data,
    loading
  }
}

export default useXclient
